import axios from '../utilities/axios'
import { bgUtil } from '../utilities/specialPromotion.util'

const loadSpecialPromotion = async payload =>
  axios.post('/api/v1/specialPromotion/', payload).then(({ specialPromotion }) => {
    const {
      content: {
        content_localization: { imageUrlLogo, imageUrlHeroLarge, imageUrlHeroSmall },
        content_provider: { name },
      },
      expiredAt,
      pageUrl,
      termsId,
    } = specialPromotion

    return {
      imageUrlHeroLarge: bgUtil(imageUrlHeroLarge.localizationStrings[0].body),
      imageUrlLogo: bgUtil(imageUrlLogo.localizationStrings[0].body),
      imageUrlHeroSmall: bgUtil(imageUrlHeroSmall.localizationStrings[0].body),
      contentProviderName: name,
      expiredAt,
      pageUrl,
      termsId,
    }
  })

async function redeemPromotion(payload) {
  const { pageUrl } = payload
  return axios.post('/api/v1/specialPromotion/redeem', { pageUrl })
}

async function getTerms(payload) {
  const { termsId } = payload
  return axios.get(`/api/v1/specialPromotion/terms?termsId=${termsId}`)
}

async function getPromotions() {
  return axios.get('/api/v1/specialPromotion/promotions').then(promotions =>
    promotions.map(promotion => ({
      url: `/${promotion.page.pageUrl}`,
      id: promotion.page.pageUrl,
      active: promotion.page.active,
      pageUrl: promotion.page.pageUrl,
      promotionImgName: promotion.page.promotionImgName,
      productImgName: promotion.page.productImgName,
      provider: promotion.content.content_provider.name,
      promotionTermId: promotion.promotionTermId,
    }))
  )
}

export default {
  loadSpecialPromotion,
  redeemPromotion,
  getTerms,
  getPromotions,
}
